import { render, staticRenderFns } from "./FarmerProductionChart.vue?vue&type=template&id=25e3bb2e"
import script from "./FarmerProductionChart.vue?vue&type=script&lang=js"
export * from "./FarmerProductionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports